import * as React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const PhoneIcon = (props) => {
  const {fill= '#fff'} = props;
  return (
    <SvgIcon {...props} style={{ fill}} viewBox="0 0 17.915 18">
      <path className="a"
            d="M344.505,99.515l-.854.285h0Zm1.348,4.044-.854.284Zm-.452,1.09.4.8h0Zm-2.031,1.015-.4-.8a.9.9,0,0,0-.418,1.175Zm4.965,4.965-.371.821a.9.9,0,0,0,1.175-.418Zm1.015-2.031-.8-.4Zm1.09-.452-.284.854h0Zm4.044,1.348.284-.854ZM340.7,98a2.7,2.7,0,0,0-2.7,2.7h1.8a.9.9,0,0,1,.9-.9Zm2.951,0H340.7v1.8h2.951Zm1.708,1.231A1.8,1.8,0,0,0,343.651,98v1.8h0Zm1.347,4.044-1.347-4.044-1.708.569L345,103.844Zm-.9,2.179a1.8,1.8,0,0,0,.9-2.179l-1.707.569h0Zm-2.031,1.016,2.031-1.016-.8-1.61-2.031,1.016Zm4.933,3.339a9.034,9.034,0,0,1-4.514-4.514l-1.642.741a10.841,10.841,0,0,0,5.415,5.415Zm-.159-1.613-1.016,2.031,1.61.8L350.156,109Zm2.179-.9a1.8,1.8,0,0,0-2.179.9l1.61.8h0Zm4.044,1.347-4.044-1.347L350.156,109l4.044,1.348ZM356,110.349a1.8,1.8,0,0,0-1.231-1.708l-.569,1.708Zm0,2.951v-2.951h-1.8V113.3Zm-2.7,2.7a2.7,2.7,0,0,0,2.7-2.7h-1.8a.9.9,0,0,1-.9.9Zm-.9,0h.9v-1.8h-.9ZM338,101.6A14.4,14.4,0,0,0,352.4,116v-1.8a12.6,12.6,0,0,1-12.6-12.6Zm0-.9v.9h1.8v-.9Z"
            transform="translate(-338 -98)"/>
    </SvgIcon>
  );
};

export default PhoneIcon;
